export default "__VITE_ASSET__WGJRa756__"